import { createFileRoute, redirect } from '@tanstack/react-router'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import i18n from '@/i18n'
import { AllCoursesView, coursesFiltersSchema } from '@/modules/courses'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute('/_auth/courses/all-courses')({
  validateSearch: search => coursesFiltersSchema.parse(search),
  component: () => <AllCoursesView />,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context }) => {
    const semesters = await context.queryClient.ensureQueryData(
      semesterQueryOptions({})
    )

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(
        search.semester,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/courses/all-courses',
        search: {
          semester: semesters.currentSemester?.id,
          page: 1,
          pageSize: DEFAULT_PAGE_SIZE
        }
      })
    }
  },
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.courses', { ns: 'courses' }),
      i18n.t('title.all-courses-and-groups', { ns: 'courses' })
    ])
})
